// Lightweight pub/sub + localStorage store for the "Compare with Abay AI" tray.
const KEY = "abay360:compare";
const MAX = 4;
const listeners = new Set();

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch {}
  listeners.forEach((cb) => { try { cb(list); } catch {} });
}

export const compareStore = {
  get: () => read(),
  has: (id) => read().some((x) => x.id === id),
  count: () => read().length,
  add(item) {
    if (!item?.id) return read();
    const list = read();
    if (list.some((x) => x.id === item.id)) return list;
    if (list.length >= MAX) return list; // capped
    const next = [...list, item];
    write(next);
    return next;
  },
  remove(id) {
    const next = read().filter((x) => x.id !== id);
    write(next);
    return next;
  },
  toggle(item) {
    return compareStore.has(item.id) ? compareStore.remove(item.id) : compareStore.add(item);
  },
  clear() { write([]); },
  subscribe(cb) {
    listeners.add(cb);
    const onStorage = (e) => { if (e.key === KEY) cb(read()); };
    window.addEventListener("storage", onStorage);
    return () => { listeners.delete(cb); window.removeEventListener("storage", onStorage); };
  },
  MAX,
};

export default compareStore;
